import styled from "styled-components";

export const PubListWrapper = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const PubListFormWrapper = styled.div`
  width: 500px;
  height: 500px;
  background-color: #fff;
  border-radius: 10px;
  padding: 20px;

  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
`;

export const PubListItemWrapper = styled.div`
  width: 300px;
  height: 100px;
  background-color: #fff;
  border-radius: 10px;
  padding: 20px;
  color: #000;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  gap: 10px;
  cursor: pointer;
`;
